import store from '../store';
// import firebase from 'firebase/compat/app';
import firebase from 'firebase/app';
import config from '../../firebase.config.json';

export default new class {

    requestPermissions(){
        console.log("Platform Browser");
        console.log('initializeFirebase WEB')
        try {

            //register Massaging to sw
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.ready.then((registration) => {

                    console.log('serviceWorker ready')

                        if (!registration) return;

                        console.log('firebase', firebase.app())

                        // firebase.app().getToken((token) => {
                        //     console.log('token browser:', token);
                    //         this.saveTokenToFirestore(token);
                    //     });

                        // //
                        // messaging.useServiceWorker(registration); // TODO NOT A FUNTION
                        //
                        // massaging.onMessage((data) => {
                        //     console.log("On message data", data);
                        // });
                        //

                        // firebase.requestPermission()
                        //     .then(() => {
                        //         console.log("Have Permisions:");
                        //         // return messaging.getToken();
                        //     })
                        //     .then((token) => {
                        //         console.log('token browser:', token);
                        //         // this.saveTokenToFirestore(token);
                        //         // localStorage.setItem('fcm-token', token);
                        //     })
                        //     .catch(function (error) {
                        //         console.error("Error occured: ", error);
                        //     });
                        //
                        // messaging.onTokenRefresh(() => {
                        //     messaging.getToken((refreshedToken) => {
                        //         console.log('refresh token browser:', refreshedToken);
                        //         this.saveTokenToFirestore(refreshedToken);
                        //     });
                        // });

                    })
                    .catch(function (error) {
                        console.error("Error occured: ", error);
                    });
            }

        } catch (error) {
             console.error(error);
        }
    }

    saveTokenToFirestore(token){
        if (!token) return false;
        //
        const devicesRef = db.collection('devices')
        const docData = {
            token: token,
            platform: 'browser'
        };

        //if user save with user
        if(store.getters.getProfile.id) docData['userId'] = store.getters.getProfile.id;
        if(store.getters.getProfile.clientNumber) docData['clientNumber'] = store.getters.getProfile.clientNumber;
        if(store.getters.getProfile.username) docData['userName'] = store.getters.getProfile.username;

        return devicesRef.doc(token).set(docData)
            .then(function() {
                console.log("Token successfully written!");
            })
            .catch(function(error) {
                console.error("Error writing Token: ", error);
            });
    }

}